import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { vendureCacheConfig } from "@/api/vendure/cache.config";
import type { Coords } from "@/hooks/useGeolocation";
import { vendure } from "@/lib/vendure";
import type { MerchantResponse } from "./merchant.types";

const fetchBrand = createServerFn({ method: "GET" })
  .inputValidator((d: { slug: string; lat?: number; lon?: number }) => d)
  .handler(async ({ data }): Promise<MerchantResponse> => {
    const { slug, lat, lon } = data;
    const params = new URLSearchParams({ type: "storefront" });
    if (lat != null && lon != null) {
      params.set("lat", String(lat));
      params.set("lon", String(lon));
    }
    const { data: brand } = await vendure.get<MerchantResponse>(
      `/api/v1/merchant/${slug}?${params.toString()}`,
    );
    return brand;
  });

export const brandQueryOptions = (slug: string, coords?: Coords | null) =>
  queryOptions({
    queryKey: ["brand", slug, coords?.lat ?? null, coords?.lon ?? null],
    queryFn: () =>
      fetchBrand({ data: { slug, lat: coords?.lat, lon: coords?.lon } }),
    ...vendureCacheConfig,
  });
